<template>
  <svg v-if="caret" width="8" height="5" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 1l2.667 2.63h0a.261.261 0 0 0 .366 0L6.7 1"
      stroke="#282828"
      stroke-width="1.75"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    caret: {
      type: Boolean,
      default: false
    }
  }
};
</script>
